/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component }   from 'react';
import PropTypes from 'prop-types';
import { fetch }     from '@fyresite/fetch';
import queryString  from 'query-string';

import TextInput from '@fyresite/react-textinput';
import Button from '../../../components/Button'

import validator from 'validator'

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: {
        value: '',
        valid: ''
      },
      password_confirm: {
        value: '',
        valid: '',
      }
    };
  }

  async componentWillMount() {
    const parsed = queryString.parse(this.props.location.search);
    // Check that the page was given a query param
    let response = await fetch(`/api/v1/user/passwordReset/read/${parsed.email}/${parsed.token}`, {
      method:      'GET',
      credentials: process.env.NODE_ENV === 'production' ? 'same-origin' : 'include',
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => {
      return res;
    }).catch(err => {
      return {status: 501, message: `Fetch Error, ${err}`}
    });

    if (response.status !== 200) {
      Materialize.toast("Error occurred, most likely due to an invalid token", 4000, "red")
      this.props.history.push('/');
    }
  }

  handlePasswordChange(e) {
    this.setState({
      password: e.target.value
    });
  }

  handlePasswordConfirmChange(e) {
    this.setState({
      password_confirm: e.target.value
    });
  }

  onChange(field, e, inputState) {
    let state = Object.assign({}, this.state);

		state[field] = Object.assign({}, state[field], inputState);

    this.setState((prevState, props) => {
      return state;
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    if(!this.state.password.valid){
      this.password.focus();
    } else if (!this.state.password_confirm.valid) {
      this.password_confirm.focus();
    } else {
      const parsed = queryString.parse(this.props.location.search);

      let response = await fetch('/api/v1/user/passwordReset/update', {
        method: 'POST',
        credentials: process.env.NODE_ENV === 'production' ? 'same-origin' : 'include',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: parsed.email,
          resetToken: parsed.token,
          password: this.state.password.value
        })

      }).then(res => {
        return res;
      }).catch(err => {
        return {status: 501, error: err}
      });

      if(response.status !== 501){
        let json = await response.json();
        if(json.code === 200){
          Materialize.toast(json.message, 4000, 'green');
          this.props.history.push('/');
        } else {
          Materialize.toast(json.message, 4000, 'red');
        }
      }

    }
  }

  render() {
    return (
      <div className="reset-password card-wrapper">
        <div className="card-container">



          <div className="reset-card card z-depth-5" ref="login-card">
            <div className="card-content">
              <span className="card-title">AlphaScrip Web Portal</span>

              <form onSubmit={this.handleSubmit.bind(this)} className="left-align" noValidate>
                <TextInput
                  ref={input => this.password = input}
                  className=""
                  inputClassName=""
                  label="Password"
                  type="password"
                  onChange={this.onChange.bind(this, 'password')}
                  value={this.state.password.value}
                  valid={this.state.password.valid}
                  validator={val => { return validator.matches(val, /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,15}$/) }}
                  error="Password must be at least 4 characters, no more than 15 characters, and must include at least one upper case letter, one lower case letter, and one numeric digit." />
                <TextInput
                  ref={input => this.password_confirm = input}
                  className=""
                  inputClassName=""
                  label="Confirm Password"
                  type="password"
                  onChange={this.onChange.bind(this, 'password_confirm')}
                  value={this.state.password_confirm.value}
                  valid={this.state.password_confirm.valid}
                  validator={val => { return val === this.state.password.value }}
                  error="Must match the password field" />

                <Button
                  color={'red'}
                  flat={false}
                  onClick={this.handleSubmit.bind(this)}
                  z-depth={1}>
                  {"Submit"}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.contextTypes = {
  closeModal: PropTypes.func,
  router:     PropTypes.object,
  showModal:  PropTypes.func
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/pages/Home/ResetPassword/ResetPassword.js